export const HubSpotForNonprofitsTypeDecorator = {
  url() {
    return `signup-hubspot/hubspot-for-nonprofits`;
  },

  query() {
    return {};
  }

};